export var calendarTheme = {
  baseStyle: {
    position: 'relative',
    marginTop: 'm',
    paddingX: 'm',
    paddingBottom: 'm'
  }
};
//# sourceMappingURL=Calendar.theme.js.map